import { PatientVaccine, PatientVaccineControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientVaccineCreate = () =>
  useMutationWithLoading(
    async (params: { patientVaccine: PatientVaccine; xTENANTID?: string }) =>
      new PatientVaccineControllerApi(getConfigObject()).createPatientVaccine(
        params.patientVaccine,
        params.xTENANTID
      )
  );
